import React, { useState, useEffect } from 'react';
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Card,
  Button,
  Row,
  Col,
  Label,
  NavbarBrand,
  Nav,
  Navbar,
  NavbarText,
  Table,
} from 'reactstrap';
import { useSelector } from 'react-redux';
import moment from 'moment';
import { amountFormat } from '../../../utils/functions/CustomFunctions';
import defaultAvatar from '../../../assets/images/defaultImages/defaultAvatar.png';
import API from '../../../redux/actions/API';
import Swal from 'sweetalert2';
import { AGENCY_DETAILS_URL } from '../../../utils/APIEndpoints';
import {
  getCurrentAgencyId,
  getAlertToast,
} from '../../../utils/functions/CustomFunctions';
import { authHeader } from '../../../utils/functions/CoreFunctions';

function InvoicePreview(props) {
  const { modal = false, toggle, selectedCustomer = {} } = props;
  const [agencyData, setAgencyData] = useState({});
  //Invoice form Reducer
  const {
    lineItems = [],
    subTotal = 0,
    discount = 0,
    tax = 0,
    grandTotalAmount = 0,
    taxPercentage = 0,
    discountPercentage = 0,
    invoiceExpiryDate = '',
  } = useSelector((state) => state.InvoiceFormReducer);

  

  //Get Agency Data
  const getAgencyDetails = async () => {
    const options = {
      method: 'GET',
      url: AGENCY_DETAILS_URL,
      headers: authHeader(),
      params: { agencyId: getCurrentAgencyId() },
    };
    try {
      const response = await API(options);
      const { status, agency } = response.data;
      if (status === 'Success') {
        setAgencyData(agency);
      }
    } catch (error) {
      if (error.response) {
        let { data } = error.response;
        Swal.fire(getAlertToast('error', data.message));
      }
    } finally {
    }
  };

  useEffect(() => {
    getAgencyDetails();
  }, []);

  return (
    <Modal
      isOpen={modal}
      toggle={toggle}
      className="modal-dialog-centered modal-lg"
    >
      <ModalHeader toggle={toggle}>Preview invoice</ModalHeader>
      <ModalBody className="preview-invoice-model">
        <Navbar color="white">
          <NavbarBrand href="/">
            <img
              src="https://payform.us/static/media/logo.0ced2d30.png"
              className="logo mb-3 mt-3"
              alt='logo'
            />
          </NavbarBrand>
          <Nav className="me-auto" navbar></Nav>
          <NavbarText className="invoice-client-logo">
            <img
              className="uploadImg"
              src={agencyData.agencyLogo || defaultAvatar}
              alt='logo'
            />
          </NavbarText>
        </Navbar>
        <section className="invoice-tem">
          <div className="top">
            <h4>
              Invoice from {agencyData ? agencyData.companyName : 'PAYFORM.US'}
            </h4>

            {/* <p>Invoice: #1234</p> */}
          </div>
          <div>
            <Card body className="info-card cardholder-info">
              <Row className="info">
                <Col md="4">
                  <span>From</span>
                  <h5>{agencyData ? agencyData.companyName : '-'}</h5>
                </Col>
                <Col md="4">
                  <span>Phone Number</span>
                  <h5>{agencyData ? agencyData.agencyPhone : '-'}</h5>
                </Col>

                <Col md="4">
                  <span>Address</span>
                  <h5>{agencyData ? agencyData.agencyAddress : '-'}</h5>
                </Col>
              </Row>
              <Row className="info">
                <Col md="4">
                  <span>Billed to</span>
                  <h5>
                    {selectedCustomer ? selectedCustomer.customerName : '-'}
                  </h5>
                </Col>
                <Col md="4">
                  <span>Date due</span>
                  <h5>
                    {moment(invoiceExpiryDate).format('MM/DD/YYYY') || '-'}
                  </h5>
                </Col>
                <Col md="4">
                  <span>Amount due</span>
                  <h5>{amountFormat(grandTotalAmount)}</h5>
                </Col>
              </Row>
            </Card>

            <Card body className="summary-card Invoice from cardholder-info">
              <h6>Summary</h6>
              <hr className="m-0 mb-2" />
              <Table bordered className="cardholder-info invoice-preview">
                <thead>
                  <tr>
                    <th>Item</th>
                    <th>Quantity</th>
                    <th>Item Price</th>
                    <th className="text-end">Total Price</th>
                  </tr>
                </thead>
                <tbody>
                  {lineItems.map((data) => {
                    const {
                      itemDescription = '',
                      quantity = 0,
                      individualAmount = 0,
                    } = data;
                    return (
                      <tr>
                        <td>{itemDescription} </td>
                        <td>{quantity}</td>
                        <td>{amountFormat(individualAmount * 1)} </td>
                        <td className="text-end">
                          {amountFormat(quantity * individualAmount)}
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </Table>
              <hr className="m-0 mb-2" />
              <Row className="total-sec">
                <Col md="12">
                  <div className="price-list">
                    <div className="list">
                      <Label for="" className="">
                        Sub Total
                      </Label>
                      <h6>{amountFormat(subTotal)}</h6>
                    </div>
                    <div className="list">
                      <Label for="" className="">
                        Tax ({taxPercentage}%)
                      </Label>

                      <h6>{amountFormat(tax)}</h6>
                    </div>
                    <div className="list">
                      <Label for="" className="">
                        Discount ({discountPercentage}%)
                      </Label>
                      <h6>{amountFormat(discount)}</h6>
                    </div>
                    <div className="list bold">
                      <Label for="" className="">
                        Amount due
                      </Label>

                      <h6>{amountFormat(grandTotalAmount)}</h6>
                    </div>
                  </div>
                </Col>
              </Row>
            </Card>
          </div>
        </section>
      </ModalBody>
      <ModalFooter>
        <Button color="secondary" onClick={toggle}>
          Close
        </Button>
      </ModalFooter>
    </Modal>
  );
}

export default InvoicePreview;
